import React from "react";
import styles from "./ServicesOferred.module.scss";
import { ServicesCard } from "./ServicesCard/ServicesCard";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import TerrainOutlinedIcon from "@mui/icons-material/TerrainOutlined";
import BedroomChildOutlinedIcon from "@mui/icons-material/BedroomChildOutlined";

const servicesData = [
  {
    icon: HomeOutlinedIcon,
    title: "Vende tu casa",
    description:
      "Maximiza el retorno de tu inversión con un proceso eficiente y transparente. Nos encargamos de valorar, promocionar y cerrar la venta de tu propiedad, asegurando una experiencia sin complicaciones.",
  },
  {
    icon: KeyOutlinedIcon,
    title: "Renta tu casa",
    description:
      "Convierte tu propiedad en una fuente constante de ingresos. Nuestro equipo se encarga de encontrar inquilinos confiables, gestionar contratos y garantizar que tu casa esté en las mejores manos.",
  },
  {
    icon: TerrainOutlinedIcon,
    title: "Vende tu terreno",
    description:
      "Obtén el mejor precio por tu parcela o terreno. Gracias a nuestro profundo conocimiento del mercado, aseguramos que tu terreno llegue a inversores y compradores potenciales de forma efectiva.",
  },
  {
    icon: BedroomChildOutlinedIcon,
    title: "Renta vacacional",
    description:
      "Transforma tu propiedad en un destino deseado para viajeros. Gestionamos todo, desde la promoción en plataformas populares hasta el mantenimiento, para que obtengas beneficios sin preocuparte por los detalles.",
  },
];

export const ServicesOferred = () => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>Servicios ofrecidos</p>
      <p className={styles.subtitle}>
        Obten ayuda para realizar tus operaciones con la mejor asesoria y
        servicio, tanto para dueños de propiedades, como para interesados.
      </p>
      <div className={styles.servicesContainer}>
        {servicesData.map((service, idx) => {
          return (
            <ServicesCard
              key={idx}
              Icon={service.icon}
              title={service.title}
              description={service.description}
            />
          );
        })}
      </div>
    </div>
  );
};
